import UserMenu from './UserMenuContainer';
export default UserMenu;